import React from 'react';
import Modal from '@omilia/modal';

import messages from 'constants/messages';
import LoadingModalContent from '../../components/LoadingModalContent';

type Props = {
  isFetch: boolean;
  loadingStatus: boolean;
};

const titleMessages = messages.VERSION_CONTROL.MODAL;

const LoadingModal = ({ isFetch, loadingStatus }: Props) => {
  const getLoadingText = () => {
    if (loadingStatus) {
      return isFetch
        ? messages.VERSION_CONTROL.MODAL.GIT_STATUS.LOADING_MSG_FETCH
        : messages.VERSION_CONTROL.MODAL.GIT_STATUS.LOADING_MSG_COMMIT;
    }

    return messages.VERSION_CONTROL.MODAL.FETCH.LOADING_MSG;
  };

  return (
    <Modal
      open
      glyph="commit"
      hasBackdrop={false}
      title={
        isFetch
          ? titleMessages.FETCH.GENERAL_TITLE
          : titleMessages.COMMIT.GENERAL_TITLE
      }
    >
      <LoadingModalContent loadingText={getLoadingText()} />
    </Modal>
  );
};

export default LoadingModal;
